// Application types

const THIRDPARTY = {
  LOADING: "LOADING",
  CREATING: "CREATING",
  DELETING: "DELETING",
  MY_THIRD_PARTY_WEBHOOKS: "MY_THIRD_PARTY_WEBHOOKS",
  CREATE_THIRD_PARTY_WEBHOOK: "CREATE_THIRD_PARTY_WEBHOOK",
  DELETE_THIRD_PARTY_WEBHOOK: "DELETE_THIRD_PARTY_WEBHOOK",
};

export default THIRDPARTY;
